<template>
    <div>
        <kgr-member-login-overview :club-id="clubId" />
        <kgr-club-stocktaking :club-id="clubId" />
    </div>
</template>

<script>
import MemberLoginOverview from '../../components/club/statistics/MemberLoginOverview.vue';
import MemberStocktaking from '../../components/club/statistics/MemberStocktaking.vue';

export default {
    name: 'Statistics',
    components: {
        'kgr-club-stocktaking': MemberStocktaking,
        'kgr-member-login-overview': MemberLoginOverview,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
    },
};
</script>

<style scoped>

</style>
